import ApiService from "@/services";
import { handleApiError } from "../helpers";

const state = {
  pending: false,
};

const getters = {};

const mutations = {
  setPending(state, value) {
    state.pending = value;
  },
};

const actions = {
  async initiateBookingOnRequest({ commit }, payload) {
    commit("setPending", true);
    try {
      await ApiService.post("booking/request", payload);
    } catch (error) {
      throw handleApiError(error);
    } finally {
      commit("setPending", false);
    }
  },
  async getPaymentCardForm(_, payload) {
    try {
      return await ApiService.post("pci-booking/card-form", payload);
    } catch (error) {
      throw handleApiError(error);
    }
  },
  async processCultswitchBooking(_, payload) {
    try {
      return await ApiService.post("booking/cultswitch/process", payload);
    } catch (error) {
      throw handleApiError(error);
    }
  },
  async processEhotelBooking(_, payload) {
    try {
      return await ApiService.post("booking/ehotel/process", payload);
    } catch (error) {
      throw handleApiError(error);
    }
  },
  async processNuiteeBooking(_, payload) {
    try {
      return await ApiService.post("booking/nuitee/process", payload);
    } catch (error) {
      throw handleApiError(error);
    }
  },
  async cancelBooking(_, payload) {
    try {
      await ApiService.post("booking/cancel", payload);
    } catch (error) {
      throw handleApiError(error);
    }
  },
  async getCancelPolicy(_, { provider, bookingId }) {
    try {
      const { data } = await ApiService.get(
        `booking/cancel-policy/${provider}/${bookingId}`
      );
      return data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
  async nuiteePrebook(_, payload) {
    try {
      const { data } = await ApiService.post("booking/nuitee/prebook", payload);
      return data?.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
